const KG_FMT = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
const LEI_FMT = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Format `1234.500` -> `1.234,500` (Romanian locale, 3-decimal kg). */
export function formatKg(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '0,000';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return KG_FMT.format(n);
}

/** Format `1234.5` -> `1.234,50` (Romanian locale, 2-decimal lei). */
export function formatLei(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '0,00';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return LEI_FMT.format(n);
}

const TIME_ZONE = 'Europe/Bucharest';
const DATE_FMT = new Intl.DateTimeFormat('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: TIME_ZONE });
const DATE_TIME_FMT = new Intl.DateTimeFormat('ro-RO', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: TIME_ZONE,
});
const INT_FMT = new Intl.NumberFormat('ro-RO');
const PLURAL = new Intl.PluralRules('ro');

// A bare `YYYY-MM-DD` is a calendar day, not an instant: parsing it as UTC and
// formatting in Bucharest is right, but only because Bucharest is ahead of UTC.
function toDate(value: string | Date): Date | null {
  const d = value instanceof Date ? value : new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00Z` : value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** `2026-09-26` / ISO instant -> `26.09.2026`. */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d = toDate(value);
  return d ? DATE_FMT.format(d) : String(value);
}

/** ISO instant -> `26.09.2026, 14:05`. */
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d = toDate(value);
  return d ? DATE_TIME_FMT.format(d) : String(value);
}

/** `1284930` -> `1.284.930`. */
export function formatInt(value: number): string {
  return INT_FMT.format(value);
}

/**
 * Romanian plural with the „de” form: pluralRo(1, 'rezultat', 'rezultate')
 * -> „1 rezultat”, 5 -> „5 rezultate”, 20 -> „20 de rezultate”.
 */
export function pluralRo(count: number, one: string, many: string): string {
  const category = PLURAL.select(count);
  if (category === 'one') return `${formatInt(count)} ${one}`;
  if (category === 'few') return `${formatInt(count)} ${many}`;
  return `${formatInt(count)} de ${many}`;
}

/**
 * Accent- and case-insensitive key for matching: „Ștefan”, „Ştefan” (cedilla,
 * from old imports) and „stefan” all become „stefan”.
 */
export function normalizeSearch(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim();
}
